import { BoardEvent, BoardEventKind } from './BoardEvent'
import { GameEvent, GameEventKind } from './GameEvent'
import { PlayerEvent, PlayerEventKind } from './PlayerEvent'
import { TableEvent, TableEventKind } from './TableEvent'

export type ShippableEventId = string
export type ShippableEvent = GameEvent | TableEvent | BoardEvent | PlayerEvent
export type ShippableEventKind = GameEventKind | TableEventKind | BoardEventKind | PlayerEventKind

export const isGameEvent = (event: GameEvent | unknown): event is GameEvent => {
  return (
    (event as GameEvent)?.snapshot !== undefined && Object.values(GameEventKind).includes((event as GameEvent).kind)
  )
}

export const isTableEvent = (event: TableEvent | unknown): event is TableEvent => {
  return (
    (event as TableEvent)?.snapshot !== undefined && Object.values(TableEventKind).includes((event as TableEvent).kind)
  )
}

export const typeSafeEventCompare = (eventKinds: ShippableEventKind[], kind: ShippableEventKind) =>
  eventKinds.includes(kind)
